import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { compose } from 'redux';
import some from 'lodash/some'
 
import { Button } from 'primereact/button';
import { confirmDialog } from 'primereact/confirmdialog';

import SecureCode from '@components/SecureCode'

import { validateToken, forgotPassword } from '@actions/auth';


// import './style.scss'

class TokenPassord extends Component {
  constructor(props) {
    super(props);
    this.state = {
      btnSubmitLoading: false,
      secureCode:{
				codeSec1: '',
				codeSec2: '',
				codeSec3: '',
				codeSec4: '',
				codeSec5: '',
				codeSec6: ''
			},
      isTokenInvalid: false,
      email: '',
      errors: [],
    };
  }

  componentDidMount () {
    const { history } = this.props
    if (!history?.location?.state?.email) return history.push("/forgot-password")
    return this.setState({email: history?.location?.state?.email})
  }

  onChange = ({ target }) => {
    this.setState({ [target.name]: target.value }, this.validateFieldsOnchange(target.name, target.value));
  };

  validateFieldsOnchange = (name, value) => {
    const { errors } = this.state;
    if (errors[name] && value) {
      delete errors[name];
      this.setState({ errors });
    }
  };

  validateFields = async () => {
    const { t } = this.props;
    const { secureCode, isTokenInvalid } = this.state;
    let errors = {};
    const validateCode = Object.values(secureCode).join('')
    console.log('validateCode', validateCode, validateCode.length)
    if (!validateCode || validateCode.length !== 6 ) errors = { ...errors, 'secureCode': `${'Código de seguridad'} ${t('es requerido')}` }
    if (validateCode && validateCode.length === 6 && isTokenInvalid ) errors = { ...errors, 'secureCode': `${'Código inválido'}` }
    this.setState({ errors });
    return errors;
  };

  onSubmit = async (e) => {
    e.preventDefault();
    this.setState({btnSubmitLoading: true})
    const { history, t, validateToken } = this.props
    const { secureCode, email } = this.state
    const validate = await this.validateFields()
    if (some(validate, {})) return this.setState({btnSubmitLoading: false})

    const validateCode = Object.values(secureCode).join('')
    const response = await validateToken({ secureCode: validateCode, email })
    if (!response.status) {
      history.push({pathname: "/reset-password", state: { email }})
    } else {
      await this.setState({isTokenInvalid: true})
      this.validateFields()
    }
    return this.setState({ btnSubmitLoading: false });
  };

  resentToken = async () => {
    const { t, forgotPassword, history } = this.props
    const { email } = this.state
    this.setState({ btnSubmitLoading: true });
    const response = await forgotPassword({email})
    if (!response.status) {
      this.setState({ btnSubmitLoading: false });
      return confirmDialog({
        message: t('La operación se ha realizado de manera éxitosa'),
        header: t('Confirmación'),
        icon: 'pi pi-check-circle',
        acceptLabel: t('Continuar'),
        rejectClassName: 'hide-component',
        accept: () => {},
        onHide: () => {}
      });
    }
    return this.setState({ btnSubmitLoading: false });
  }

  getSecureCode = (secureCode) => {
		this.setState({ secureCode, isTokenInvalid: false }, this.validateFieldsOnchange('secureCode', secureCode));
	};

  render() {
    const { history, t } = this.props;
    const { secureCode, btnSubmitLoading, errors, email } = this.state;

    const isFormFieldValid = (name) => !!errors[name];
    const getFormErrorMessage = (name) =>
      isFormFieldValid(name) && (
        <small className="p-error">{errors[name]}</small>
      );

    return (
      <section className="loginCont is-full-height p-d-flex p-jc-center p-ai-center">
        <div className="conteiner">
          <div className="p-grid">
            <div className="p-col-12 card p-p-6">
              <div className="p-grid containerForm">
                <div className="p-col-3"/>
                <form onSubmit={this.onSubmit} className="p-col-6 p-fluid p-pt-5">
                  <h2 className="p-mb-6 p-text-center p-mt-5">{t("Verificación de Email")} </h2>
                  <p className="p-text-center">{t("Para continuar con el registro, hemos enviado un enviado un Código de Seguridad a la siguiente cuenta de correo:")}</p>
                  <p className="p-text-bold p-text-center p-mb-3">{email}</p>
                  <div className="p-field p-mb-5 p-text-center">
                    <label
                      htmlFor="code"
                      className="p-mb-3"
                    >
                      {t("Ingresa tu código")}
                    </label>
                    <SecureCode
                      secureCode={ secureCode }
                      getSecureCode={ this.getSecureCode }
                    />
                    <div className="p-text-center is-full-width p-mt-2">
                      {getFormErrorMessage('secureCode')}
                    </div>
                  </div>
                  <Button
                    type="submit"
                    label={t("Validar código")}
                    className="p-button"
                    loading={btnSubmitLoading}
                    loadingoptions={{ position: 'right' }}
                  />
                  {/* <Button type="submit" label="Enviar" className="p-button-lg p-mt-3" loading={btnSubmitLoading} loadingoptions={{ position: 'right' }}/> */}
                  <p className="p-text-center p-mt-3">
                    {t("Si no recibiste el código de seguridad")}  <label className="link" onClick={() => this.resentToken()}>{t("haz click aquí")}</label>
                  </p>
                  <p className="p-text-center"> {t("para que te reenviemos el correo.")}</p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

const mapDispatchToProps = {
  validateToken,
  forgotPassword
};

export default compose(
  withTranslation(),
  connect(null, mapDispatchToProps)
)(TokenPassord);
